import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=13c30656&scoped=true&"
import script from "./Cover.vue?vue&type=script&lang=js&"
export * from "./Cover.vue?vue&type=script&lang=js&"
import style0 from "./Cover.vue?vue&type=style&index=0&id=13c30656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c30656",
  null
  
)

export default component.exports